import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
    Carousel,
    FeedbackCard,
    HarassmentRiskCard,
    OnboardingCard,
    HarassmentRiskCardProps,
} from '@diversioteam/diversio-ds'
import { Autoplay, Pagination } from 'swiper'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { useUserInformation } from 'hooks/useUserInformation'
import { useRiskBanner, GetRiskBannerResponse } from 'hooks/useRiskBanner'
import { RawProgressBannerProps, useProgressBanner } from '../../hooks/useProgressBanner'

type BannerCarouselProps = {
    isFirstLogin: boolean
    handleShowOnboarding: () => void
    onViewDisclaimer: () => void
}

const BannerCarouselWithoutEB = (props: BannerCarouselProps) => {
    const { fullname } = useUserInformation()
    const { data: riskData, isLoading: isRiskBannerLoading } = useRiskBanner()
    const { data: progressData, isLoading: isProgressBannerLoading } = useProgressBanner()

    const { isFirstLogin, handleShowOnboarding } = props

    const onboardingComponent = useMemo(
        () => (
            <OnboardingCard
                key={1}
                name={fullname || undefined}
                linkProps={{
                    component: 'div',
                    onClick: handleShowOnboarding,
                }}
                isFirstLogin={isFirstLogin}
            />
        ),
        [],
    )

    if (isRiskBannerLoading || isProgressBannerLoading || !riskData || !progressData) {
        return null
    }

    const hasProgressData = progressData.length > 0

    const progressComponents = hasProgressData
        ? progressData.map((progress: RawProgressBannerProps, id) => (
              <FeedbackCard key={id + 2} title={progress.text} />
          ))
        : []

    const isRiskDataAvailable = (data: GetRiskBannerResponse): data is HarassmentRiskCardProps<'a'> => {
        return 'title' in data
    }

    const harassmentComponent = isRiskDataAvailable(riskData)
        ? [
              <HarassmentRiskCard
                  key={100}
                  {...riskData}
                  onViewDisclaimer={props.onViewDisclaimer}
                  linkProps={{
                      component: Link,
                      to: '/goals',
                  }}
              />,
          ]
        : []

    return (
        <div className="ddsi-card banner-carousel">
            <Carousel
                elements={[onboardingComponent, ...progressComponents, ...harassmentComponent]}
                title={undefined}
                topNavigation={false}
                swiperProps={{
                    loop: true,
                    autoplay: {
                        delay: 4000,
                        pauseOnMouseEnter: true,
                    },
                    modules: [Autoplay, Pagination],
                }}
            />
        </div>
    )
}

export const BannerCarousel = withErrorBoundary(BannerCarouselWithoutEB, {})
